export const GATEWAY_SERVICES_TIMEOUT_ERROR: string = 'gateway/services/TIMEOUT_ERROR';
